import { render, staticRenderFns } from "./PresellBookSet.vue?vue&type=template&id=a12b6f48&scoped=true"
import script from "./PresellBookSet.vue?vue&type=script&lang=js"
export * from "./PresellBookSet.vue?vue&type=script&lang=js"
import style0 from "./PresellBookSet.vue?vue&type=style&index=0&id=a12b6f48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12b6f48",
  null
  
)

export default component.exports